const RB062RED = require('./RB062RED.webp');
export default [RB062RED];
